import React from 'react';
import styles from './survey.module.sass';
import cn from 'classnames';
import { FontIcon } from '../FontIcon';
import { Skeleton } from '../Skeleton';
import { LazyImage } from '../LazyImage';

interface FavSurveyProps extends React.HTMLAttributes<HTMLDivElement> {
    id: string;
    image: string | React.ReactElement;
    selected?: boolean;
    onClick?: () => void;
    isLoading?: boolean;
}

export const FavSurvey = ({ id, image, selected, onClick, isLoading, className, ...props }: FavSurveyProps) => {
    const classes = cn(styles.fav, selected && styles.selected, className);

    if (isLoading) {
        return (
            <div className={classes} {...props}>
                <Skeleton variant="rounded" absolute />
            </div>
        );
    }

    return (
        <div className={classes} onClick={onClick} {...props}>
            {typeof image === 'string' ? <LazyImage src={image} alt="" /> : image}
            <div className={styles.icon}>
                <FontIcon
                    name={selected ? 'like-filled' : 'like'}
                    size="smaller"
                    md="medium"
                    color={selected ? 'orange' : ''}
                />
            </div>
        </div>
    );
};
